export default {
  namespaced: true,
  state () {
    return {
      auth: null,
      loading: null,
      service: null,
      group: null,
      user: null,
      routine: null,
      tab: null,
      data: null,
      chat: null
    }
  },
  getters: {
    auth (state) {
      return state.auth
    },
    loading (state) {
      return state.loading
    },
    service (state) {
      return state.service
    },
    group (state) {
      return state.group
    },
    user (state) {
      return state.user
    },
    routine (state) {
      return state.routine
    },
    tab (state) {
      return state.tab
    },
    data (state) {
      return state.data
    },
    chat (state) {
      return state.chat
    }
  },
  mutations: {
    setAuth (state, payload) {
      state.auth = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setService (state, payload) {
      state.service = payload
    },
    setGroup (state, payload) {
      state.group = payload
    },
    setUser (state, payload) {
      state.user = payload
    },
    setRoutine (state, payloda) {
      state.routine = payloda
    },
    setTab (state, payload) {
      state.tab = payload
    },
    setData (state, payload) {
      state.data = payload
    },
    setChat (state, payload) {
      state.chat = payload
    }
  },
  actions: {
    setAuth ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setAuth', payload)
        resolve()
      })
    },
    setLoading ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', payload)
        resolve()
      })
    },
    setService ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setService', payload)
        resolve()
      })
    },
    setGroup ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setGroup', payload)
        resolve()
      })
    },
    setUser ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setUser', payload)
        resolve()
      })
    },
    setRoutine ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setRoutine', payload)
        resolve()
      })
    },
    setTab ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setTab', payload)
        resolve()
      })
    },
    setData ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setData', payload)
        resolve()
      })
    },
    setChat ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setChat', payload)
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Dispatch.js